import React from 'react';
import './../css/services.css';

const Services = () => {
  return (
    <section id="services" className="services">
      <h2>Our Services</h2>
      <p className="textbox">Explore our cybersecurity services suite designed to protect and fortify your digital environment.</p>
      <div className="services-grid">
        <div className="service-card">
          <h3>Threat Modeling</h3>
          <p>Helps in identifying and mitigating potential vulnerabilities before they can be exploited by cyber attackers.</p>
        </div>
        <div className="service-card">
          <h3>Application Security</h3>
          <p>Safeguard your applications with our Cloud security, ZTA, VAPT and DevSecOps services to ensure robust protection and compliance.</p>
        </div>
        <div className="service-card">
          <h3>Attack Surface Management</h3>
          <p>Assess your digital landscape to uncover exposure metrics, analyze vulnerabilities, and enable strategic security enhancements.</p>
        </div>
        <div className="service-card">
          <h3>Cybersecurity Advisory</h3>
          <p>Get expert guidance on cybersecurity strategy, privacy controls, policy development, and threat mitigation, tailored to your business needs.</p>
        </div>
      </div>
      <p className="cta-text"><br/><a href="mailto:contact@defensek.com" className="email-link">contact@defensek.com</a></p>
    </section>
  );
};

export default Services;
